<template>
  <div class="ChallengesAssociateTechniquesSearchBar">
    <div class="container-fluid ">
		  <div class="row margin-Top-2Perc margin-bottom-2Perc">
		      <div class="col-xs-1 col-sm-1 col-md-1 col-lg-2">
          </div>
          <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 font-size-18px text-align-right margin-Top-4Px padding-right-0Px">
            Challenge
          </div>
          <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8 text-align-left">
            <div class="row">
              <div class="col-xs-5 col-sm-5 col-md-5 col-lg-5">
                <select class="form-control width-90Perc" v-model="ChallengeObjValue">
                  <option value=-1 disabled>Select</option>
                    <option v-for="singleChallengeObj in challengeObjectList" v-bind:key="singleChallengeObj.ChallengeId" v-bind:value="singleChallengeObj">{{ singleChallengeObj.Title }}</option>
                </select>                  
              </div>
              <div class="col-xs-2 col-sm-2 col-md-1 col-lg-1 text-align-center">  
                  <button type="button" class="btn black-border custom-btn white-BG" @click="showAssociatedTechniques">Go</button>
              </div>
              <div class="col-xs-4 col-sm-4 col-md-6 col-lg-6 left-border padding-Left-30px">  
                  <button type="button" class="btn black-border custom-btn white-BG" @click="checkBeforeAssociateTechnique"> Associate</button>
              </div>
            </div>
          </div>   
      </div>
    </div>
    <confirmation-alert v-if="showConfirmationBox" v-bind:dataObj="null" v-bind:prefixString="prefixConfirmationString" v-bind:postfixString="postConfirmationString" @showConfirmationBox="updateShowConfirmationAlertFlag" @userConfirmation="performOperation"></confirmation-alert>
    <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
    <!-- Show Spinner -->
    <div class="animationload" v-show="showSpinner">
      <div class="osahanloading"></div>
    </div>
    <loader></loader>
  </div>
</template>
<script>
import { constants } from '@/utils/constants'
import { challengeService } from '@/server-util/challenge-service'
import { techniqueService } from '@/server-util/technique-service'
import ConfirmationOverlay from '@/components/ConfirmationOverlay'
import AlertBox from '@/components/AlertOverlay'
import Loader from '@/components/dashboard/Loader'
export default {
  created: function () {
    this.getChallenges()
  },
  data: function () {
    return {
      selectedChallengeObj: -1,
      showAlertDialog: false,
      errorMsg: '',
      showSpinner: false,
      showConfirmationBox: false,
      prefixConfirmationString: 'Are you sure you want to associate ',
      postConfirmationString: ' this challenge?'
    }
  },
  components: {
    'alert-box': AlertBox,
    'confirmation-alert': ConfirmationOverlay,
    'loader': Loader
  },
  name: 'ChallengesAssociateTechniquesSearchBar',
  computed: {
    ChallengeObjValue: {
      get: function () {
        return this.selectedChallengeObj
      },
      set: function (newValue) {
        this.selectedChallengeObj = newValue
      }
    },
    challengeObjectList: {
      get: function () {
        return this.$store.state.challengeList
      }
    }
  },
  methods: {
    checkBeforeAssociateTechnique: function () {
      if (this.selectedChallengeObj !== -1 && this.selectedChallengeObj !== null) {
        // this.$emit('selectedChallengeObj', this.selectedChallengeObj)
        this.showConfirmationBox = true
        this.postConfirmationString = 'the techniques for \'' + this.selectedChallengeObj.Title + '\' challenge?'
      } else {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a challenge to associate technique(s).'
      }
    },
    showAssociatedTechniques: function () {
      if (this.selectedChallengeObj !== -1 && this.selectedChallengeObj !== null) {
        this.getAssociateTechniquesFromServer()
      } else {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a challenge to view it\'s associated technique(s).'
      }
    },
    performOperation (value) {
      // AK: If user pressed OK then associate it
      this.showConfirmationBox = false
      if (value) {
        this.associateTechniqueOnServer()
      }
    },
    updateShowConfirmationAlertFlag (value) {
      // AK: Used when user pressed close button of delete lesson overlay
      this.showConfirmationBox = value
    },
    getChallenges: function () {
      var _this = this
      var storeObj = this.$store
      if (
        storeObj.state.access_token !== undefined ||
        storeObj.state.access_token !== '' ||
        storeObj.state.access_token !== null
      ) {
        if (storeObj.state.challengeList.length === 0) {
          // AK: Start showing spinner only if challenge list not found
          // _this.showSpinner = true
          _this.$store.state.isLoading = true
        }

        challengeService.getAllChallenges(storeObj.state.access_token).then(
          responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store it
              storeObj.state.challengeList = responseObj.data
              if (_this.$store.state.isLoading === true) {
                // AK: Hide Spinner if its showing to user
                // _this.showSpinner = false
                this.$store.state.isLoading = false
              }
            } else {
              if (this.$store.state.isLoading === true) {
                // AK: Hide Spinner if its showing to user
                // _this.showSpinner = false
                _this.$store.state.isLoading = false
              }
              this.showAlertDialog = true
              this.errorMsg =
                'Oops! Something went wrong. Please try again.'
            }
          },
          errorObj => {
            if (_this.$store.state.isLoading === true) {
              // AK: Hide Spinner if its showing to user
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
            }
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          }
        )
      } else {
        console.log(
          'ACCESS TOKEN is NULL hence declined GET CHALLENGE LIST OPERATION'
        )
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    associateTechniqueOnServer: function () {
      var _this = this
      var storeObj = this.$store
      if (
        this.selectedChallengeObj !== undefined ||
        this.selectedChallengeObj !== '' ||
        this.selectedChallengeObj !== null
      ) {
        // AK: Start showing spinner
        // _this.showSpinner = true
        this.$store.state.isLoading = true
        techniqueService.associateTechnique(storeObj.state.access_token, this.selectedChallengeObj.ChallengeId).then(
          responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              if (_this.$store.state.isLoading === true) {
                // AK: Hide Spinner
                _this.getAssociateTechniquesFromServer()
              } else {
                // AK: Hide Spinner
                // _this.showSpinner = false
                _this.$store.state.isLoading = false
                this.showAlertDialog = true
                this.errorMsg =
                  'Oops! Something went wrong. Please try again.'
              }
            }
          },
          errorObj => {
            // AK: Hide Spinner
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          }
        )
      } else {
        console.log(
          'Challenge Object is NULL hence declined ASSOCIATION OF TECHNIQUE OPERATION'
        )
      }
    },
    getAssociateTechniquesFromServer: function () {
      var _this = this
      var storeObj = this.$store
      if (
        this.selectedChallengeObj !== undefined ||
        this.selectedChallengeObj !== '' ||
        this.selectedChallengeObj !== null
      ) {
        // AK: Start showing spinner
        // _this.showSpinner = true
        this.$store.state.isLoading = true
        techniqueService.getAssociateTechniques(storeObj.state.access_token, this.selectedChallengeObj.ChallengeId).then(
          responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              if (_this.$store.state.isLoading === true) {
                // AK: Hide Spinner
                // _this.showSpinner = false
                _this.$store.state.isLoading = false
                _this.$emit('showList', true)
                _this.$emit('selectedChallengeObj', _this.selectedChallengeObj)
                _this.$emit('parseTechniqueResponse', responseObj.data)
              } else {
                // AK: Hide Spinner
                // _this.showSpinner = false
                _this.$store.state.isLoading = false
                this.showAlertDialog = true
                this.errorMsg =
                  'Oops! Something went wrong. Please try again.'
              }
            }
          },
          errorObj => {
            // AK: Hide Spinner
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          }
        )
      } else {
        console.log(
          'Challenge Object is NULL hence declined ASSOCIATION OF TECHNIQUE OPERATION'
        )
      }
    }
  }
}
</script>
<style scoped>
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.ChallengesAssociateTechniquesSearchBar {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.font-size-18px
{
  font-size:18px;
}
.margin-Top-1Perc {
  margin-top: 1%;
}
.margin-Top-4Px {
  margin-top: 4px;
}
.black-border {
  border: 1px solid #aaa;
}
.custom-btn {
  padding: 5px 12px !important;
}
.padding-Left-30px {
  padding-left: 3% !important;
}
.white-BG {
  background-color: #ffffff;
}
.padding-Left-0px {
  padding-left: 0px !important;
}
.border-red{
  border: 1px solid red;
}
.border-yellow{
  border: 2px solid yellow !important;
}
.text-align-right {
  text-align: right;
}
.padding-right-0Px{
  padding-right: 0px !important;
}
.margin-Top-2Perc{
  margin-Top:2%;
}
</style>



// WEBPACK FOOTER //
// src/components/ChallengesAssociateTechniquesSearchBar.vue